<header class="support-documentation__title">
  <div class="icon" *ngIf="icon">
    <sbnb-support-documentation-icon [icon]="icon"></sbnb-support-documentation-icon>
  </div>
  <h3 [id]="id">{{ title }}</h3>
</header>
